// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '1582eb230dcea5542e736914d058f8c5fec55cb3';
export const BUILD_NUMBER = '241';
export const BUILD_TIMESTAMP = '2026-09-16T09:49:57.755Z';
